import React from 'react';
import PropTypes from 'prop-types';
import Stats from './Stats';
import Description from './Description';

import './style.scss';

const StatsDesc = (props) => {
    const {
        description,
        recentDelivery,
        country,
        memberSince,
        responseTime
    } = props;

    return (
        <div className="stats-desc">
            <Stats country={country} memberSince={memberSince} responseTime={responseTime} recentDelivery={recentDelivery}/>
            {description &&
            <Description userDescription={description}/>
            }
        </div>
    );
};

StatsDesc.propTypes = {
    description: PropTypes.string,
    recentDelivery: PropTypes.number,
    country: PropTypes.string,
    memberSince: PropTypes.number,
    responseTime: PropTypes.number
};

export default StatsDesc;
